import React from 'react';
import styled from 'styled-components';

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  description?: string;
  note?: string;
}

const HeroContainer = styled.div`
  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.15);
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0 12px 0;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0 0 12px 0;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Description = styled.p`
  font-size: 0.95rem;
  margin: 0 auto 12px auto;
  max-width: 800px;
  line-height: 1.5;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0 10px;
  }
`;

const Note = styled.p`
  font-size: 0.9rem;
  margin: 0 auto;
  max-width: 800px;
  line-height: 1.5;
  font-style: italic;
  opacity: 0.85;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 0 10px;
  }
`;

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  description,
  note,
}) => {
  return (
    <HeroContainer>
      <Title>{title}</Title>
      
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      
      {description && <Description>{description}</Description>}
      
      {note && <Note>{note}</Note>}
    </HeroContainer>
  );
};

export default HeroSection;
